import React from 'react'
import { Slider, Handles, Tracks, Rail, Ticks } from 'react-compound-slider'
import './styles.scss'
const ISMOBILE = window.innerWidth < 711
const tickdates = (ISMOBILE
  ? ['2020-01-01', '2021-01-01', '2022-01-01']
  : [
      '2020-01-01',
      '2020-04-01',
      '2020-07-01',
      '2020-10-01',
      '2021-01-01',
      '2021-04-01',
      '2021-07-01',
      '2021-10-01',
      '2022-01-01',
      '2022-04-01',
      '2022-07-01'
    ]
).map(m => +new Date(m))
const formatDate = (dateNumber: number, lang: string) => {
  return new Date(dateNumber).toLocaleDateString(lang, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}

export const RangeSlider = ({
  labels,
  lang,
  change,
  initial
}: {
  labels: string[]
  lang: string
  change: (dates: Date[]) => void
  initial: Date[]
}) => {
  return (
    <div className='RangeSlider'>
      {labels && <div className='label'>{labels[0]}</div>}
      <Slider
        domain={[+new Date('2020-01-01'), +new Date()]} // [min, max]
        values={initial.map(m => +m)} // slider values
        className='slider'
        onChange={([s, e]) => change([new Date(s), new Date(e)])}
      >
        <Rail>
          {({ getRailProps }) => {
            return (
              <div {...getRailProps()} /> // render your clickable rail!
            )
          }}
        </Rail>
        <Ticks values={tickdates}>
          {({ ticks }) => (
            <div className='slider-ticks'>
              {ticks.map((tick, i) => {
                const date = new Date(tick.value)
                const monthonly = date.toLocaleDateString(lang, {
                  month: 'short'
                })

                const yearonly = date.toLocaleDateString(lang, {
                  year: 'numeric'
                })
                return (
                  <div
                    key={`tick_${i}`}
                    className='tick'
                    style={{ left: tick.percent + '%' }}
                  >
                    <span>
                      {monthonly}
                      {date.getMonth() === 0 && (
                        <>
                          <br />
                          {yearonly}
                        </>
                      )}
                    </span>
                  </div>
                )
              })}
            </div>
          )}
        </Ticks>

        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => {
            return (
              <div {...getTrackProps()}>
                <div className='track' />
                <div
                  className='selected'
                  style={{
                    width:
                      tracks[0].target.percent - tracks[0].source.percent + '%',
                    left: tracks[0].source.percent + '%'
                  }}
                />
              </div>

              // render your (optional) tracks!
            )
          }}
        </Tracks>
        <Handles>
          {({ handles, getHandleProps }) => (
            // render your handles!
            <div className='handles'>
              {handles.map((handle, i) => {
                return (
                  <div
                    key={`handle_${i}`}
                    className='handle'
                    style={{ left: handle.percent + '%' }}
                    {...getHandleProps(handle.id)}
                  >
                    <span
                      className={
                        (i === 0 && handles[0].percent < 20) ||
                        (i === 1 && handles[1].percent < 80)
                          ? 'left'
                          : 'right'
                      }
                    >
                      {formatDate(handle.value, lang)}
                    </span>
                  </div>
                )
              })}
            </div>
          )}
        </Handles>
      </Slider>
    </div>
  )
}
